import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import {
	StewartModalComponent,
	StewartModalData,
} from '../../stewart-modal/stewart-modal.component';
import { TestHooks } from './cancelled.hooks';

@Component({
	selector: 'app-stewart-cancelled',
	templateUrl: './cancelled.component.html',
	styleUrls: ['./cancelled.component.scss'],
	standalone: false,
})
export class StewartCancelledComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	constructor(private dialog: MatDialog) {}

	openPortal() {
		const data: StewartModalData = {
			submitNewOrder: false,
		};

		this.dialog.open(StewartModalComponent, { data });
	}
}
